export const SURVEY_EVENT_NAME = {
    ALL_SURVEY_VISIT : {
        name: 'ALL_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    ALL_SURVEY_ENTRY : {
        name: 'ALL_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    DRAFTS_SURVEY_VISIT : {
        name: 'DRAFTS_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    DRAFTS_SURVEY_ENTRY : {
        name: 'DRAFTS_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    COMPLETED_SURVEY_VISIT : {
        name: 'COMPLETED_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    COMPLETED_SURVEY_ENTRY : {
        name: 'COMPLETED_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    ALL_TAB_CLICK : {
        name: 'ALL_TAB_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    DRAFTS_TAB_CLICK : {
        name: 'DRAFTS_TAB_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    COMPLETED_TAB_CLICK : {
        name: 'COMPLETED_TAB_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SHARE_CLICK : {
        name: 'SHARE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    VIEW_DETAILS_CLICK : {
        name: 'VIEW_DETAILS_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    VIEW_ALL_DRAFT_CLICK : {
        name: 'VIEW_ALL_DRAFT_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CONTINUE_TO_SURVEY_CLICK : {
        name: 'CONTINUE_TO_SURVEY_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SURVEY_HASHTAG_CLICK : {
        name: 'SURVEY_HASHTAG_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    RETAKE_CLICK : {
        name: 'RETAKE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SPONSOR_CLICK : {
        name: 'SPONSOR_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SCL_CLICK : {
        name: 'SCL_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SURVEY_COMPLETE : {
        name: 'SURVEY_COMPLETE',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    QUESTIONNAIRE_SURVEY_VISIT : {
        name: 'QUESTIONNAIRE_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SURVEY_TNC_CLICK : {
        name: 'SURVEY_TNC_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    COMPLETED_QUESTIONNAIRE_SURVEY_VISIT : {
        name: 'COMPLETED_QUESTIONNAIRE_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SURVEY_CROSS_TNC_CLICK : {
        name: 'SURVEY_CROSS_TNC_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SUBMIT_SURVEY_CLICK : {
        name: 'SUBMIT_SURVEY_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CONSENT_CHECK_CLICK : {
        name: 'CONSENT_CHECK_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CROSS_QUESTIONNAIRE_CLICK : {
        name: 'CROSS_QUESTIONNAIRE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CONSENT_UNCHECK_CLICK : {
        name: 'CONSENT_UNCHECK_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    NEXT_QUESTIONNAIRE_CLICK : {
        name: 'NEXT_QUESTIONNAIRE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    LETS_GET_STARTED_CLICK : {
        name: 'LETS_GET_STARTED_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    READ_MORE_CLICK : {
        name: 'READ_MORE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    READ_LESS_CLICK : {
        name: 'READ_LESS_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    MANDATORY_CONSENT_CROSS_CLICK : {
        name: 'MANDATORY_CONSENT_CROSS_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    MANDATORY_CONSENT_CANCEL_CLICK : {
        name: 'MANDATORY_CONSENT_CANCEL_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    MANDATORY_CONSENT_AGREE_CLICK : {
        name: 'MANDATORY_CONSENT_AGREE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    } ,
    SURVEY_DETAIL_VISIT : {
        name: 'SURVEY_DETAIL_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SURVEY_DETAIL_ENTRY : {
        name: 'SURVEY_DETAIL_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    THANK_YOU_PAGE_SURVEY_VISIT: {
        name: 'THANK_YOU_PAGE_SURVEY_VISIT',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    QUESTIONNAIRE_SURVEY_ENTRY : {
        name: 'QUESTIONNAIRE_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    COMPLETED_QUESTIONNAIRE_SURVEY_ENTRY : {
        name: 'COMPLETED_QUESTIONNAIRE_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    THANK_YOU_PAGE_SURVEY_ENTRY : {
        name: 'THANK_YOU_PAGE_SURVEY_ENTRY',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    BACK_QUESTIONNAIRE_CLICK : {
        name: 'BACK_QUESTIONNAIRE_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CROSS_SCL_CLICK : {
        name: 'CROSS_SCL_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    DISCARD_SURVEY_CLICK : {
        name: 'DISCARD_SURVEY_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    SUBMIT_SURVEY_CLCIK : {
        name: 'SUBMIT_SURVEY_CLCIK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CTA_1_CLICK : {
        name: 'CTA_1_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    },
    CTA_2_CLICK : {
        name: 'CTA_2_CLICK',
        hasGA: false,
        hasDQ: true,
        hasCL: false
    }
};